import $ from 'jquery';

import { registerCheckoutBlock, getRegisteredBlocks } from '@woocommerce/blocks-checkout';
import { Block } from './block.js';
import metadata  from '../block.json';

const map            = require('./map.js');
const connector      = require('./connector.js');
const uploadFFL      = require('./upload_ffl.js');
const uploadSOT      = require('./upload_sot.js');
const validation     = require('./validation.js');
let isMapInitialized = false;

registerCheckoutBlock({ metadata, component: Block });

function init() {

    waitForElement('#ffl-checkout-by-ttg-options-wrapper', function() {

        handleOptionsControl();
        handleMapInitialization();

        setInterval(function() {
            validation.handleValidationErrors();
        }, 100);

    });
    
    // FFL upload
    waitForElement('.ffl-checkout-by-ttg-file-box', function() {
        uploadFFL.init('.ffl-checkout-by-ttg-file-box', '.ffl-checkout-by-ttg-add-button');
    });
}

function handleMapInitialization() {

    $("body").on("click", '[data-init-ffl-checkout-map]',function() {

        if (!isMapInitialized) {

            setTimeout(function() {
                map.init($("#ffl-checkout-by-ttg-select-ffl-wrapper").data('lat'), $("#ffl-checkout-by-ttg-select-ffl-wrapper").data('long'), $("#ffl-checkout-by-ttg-select-ffl-wrapper").data('zoom'))
            }, 50)
            
            isMapInitialized = true;
        }
    });
}

function waitForElement(selector, callback, timeout = 10000) {

    let interval = 100; 
    let elapsedTime = 0;
    let timer = setInterval(function() {

      if ($(selector).length) {
        clearInterval(timer); 
        callback();

      } else if (elapsedTime >= timeout) {
        clearInterval(timer);
      }
  
      elapsedTime += interval;
    }, interval);
}
  

function handleOptionsControl() {

    $('input[name="ffl-checkout-by-ttg-option-selected"]').on('change', function() {

        connector.changeShippingValues("", "", "", "", "");
        connector.hideSOTUploadOptions();

        $('.ffl-checkout-by-ttg-option-body').slideUp();
        $('.ffl-checkout-by-ttg-option-body-sot').slideUp();
        $(this).parent().parent().find('.ffl-checkout-by-ttg-option-body').slideDown();
    
        let optionValue = $(this).val();
    
        switch (optionValue) {
            case 'pick_ffl':
                map.resetMap();
                break;
            case 'upload_ffl':
                uploadFFL.removeSelected();
                break;
            case 'skip_step':
                break;
            default:
                return;
                break;
        }

        $("#shipping_ffl_ttg_option").val(optionValue);
    
        // Update the hidden input value
        let optionInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_option');
        connector.changeValue(optionInput, optionValue);
    });

    $('input[name="ffl-checkout-by-ttg-option-selected-sot"]').on('change', function() {

        $("[name='shipping_ffl_ttg_cart_has_sot']").val(connector.isSOTUploadEnabled());
        let reactIsSOTRequiredInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_cart_has_sot');
            connector.changeValue(reactIsSOTRequiredInput, connector.isSOTUploadEnabled());

        $('.ffl-checkout-by-ttg-option-body-sot').slideUp();

        let optionValue = $(this).val();

        if (optionValue.length > 0) {
            $(this).parent().parent().find('.ffl-checkout-by-ttg-option-body-sot').slideDown();
        }
    
        switch (optionValue) {
            case 'upload_sot':
                
                // SOT upload
                let selectedFfl = connector.getSelectedFFL();
                if (selectedFfl.length == 0) {
                    alert("You selected an invalid FFL");
                    return;
                }

                uploadSOT.init('.ffl-checkout-by-ttg-file-box-sot', '.ffl-checkout-by-ttg-add-button-sot', selectedFfl);

                break;
            case 'already_uploaded':
                break;
            case 'skip_step_sot':
                break;
            default: 
                break;
        }

        $("#shipping_ffl_ttg_option_sot").val(optionValue);
    
        // Update the hidden input value
        let optionInput = document.getElementById('ffl-checkout-by-ttg-for-woocommerce-input-shipping_ffl_ttg_option_sot');
        connector.changeValue(optionInput, optionValue);
    });
}

document.addEventListener("DOMContentLoaded", function(event){
    init();
});